export const PENDING_QUOTES_ACTION = 'PENDING_QUOTES_ACTION'
export const COMPLETED_QUOTES_ACTION = 'COMPLETED_QUOTES_ACTION'
export const RESET_QUOTES_ACTION = 'RESET_QUOTES_ACTION'
export const SET_SUPPLIER_QUOTE = 'SET_SUPPLIER_QUOTE'
export const PENDING_GET_SUPPLIER_QUOTES = 'PENDING_GET_SUPPLIER_QUOTES'
export const SET_SUPPLIER_QUOTES_DATA = 'SET_SUPPLIER_QUOTES_DATA'
export const SORT_SUPPLIER_QUOTES = 'SORT_SUPPLIER_QUOTES'
